import { registerGlobalErrorHandlers } from "./utils/globalErrorHandler";
import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import ErrorBoundary from "./components/Common/ErrorBoundary";
import reportWebVitals from "./reportWebVitals";

import { FallingLines } from "react-loader-spinner";
registerGlobalErrorHandlers();
const App = lazy(() => import("./App"));
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Suspense
        fallback={
          <div className="flex items-center justify-center h-screen">
            <FallingLines color="#004F73" width="100" visible={true} />
          </div>
        }
      >
        <App />
      </Suspense>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
